import { MembershipType } from './member';

/** Matches backend PetitionType enum */
export enum PetitionType {
  LostMemberCard = 1,
  ChangeMembershipType = 2,
}

/** Matches backend ChangeRequestStatus for petition status */
export enum MemberPetitionStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
}

/** String names for review JSON payloads (JsonStringEnumConverter) */
export type MemberPetitionReviewStatusName = 'Pending' | 'Approved' | 'Rejected';

export const MemberPetitionReviewStatus = {
  Pending: 'Pending' as MemberPetitionReviewStatusName,
  Approved: 'Approved' as MemberPetitionReviewStatusName,
  Rejected: 'Rejected' as MemberPetitionReviewStatusName,
};

export interface MemberPetition {
  id: string;
  petitionType: PetitionType;
  status: MemberPetitionStatus;
  requestedAt: string;
  reviewedAt?: string;
  rejectionReason?: string;
  payload?: string;
  /** Admin list only */
  memberName?: string;
  /** Admin list only */
  email?: string;
  currentMembershipType?: MembershipType | null;
  targetMembershipType?: MembershipType | null;
  attachmentDocumentId?: string;
  attachmentFileName?: string;
}

export interface CreatePetitionRequest {
  petitionType: PetitionType;
  payload?: string;
  attachmentDocumentId?: string;
}

export interface ReviewMemberPetitionRequest {
  status: MemberPetitionReviewStatusName;
  rejectionReason?: string;
}

export interface PagedMemberPetitions {
  items: MemberPetition[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}
